import React from "react";
import { Users, TrendingUp, ThumbsUp, Globe2 } from "lucide-react";
import { COMPANY_STATS, SOUSCRIPTION_URL } from "../../content";

const ICONS = { Users, TrendingUp, ThumbsUp, Globe2 };

export default function CompanyStats() {
  return (
    <section
      id="qui-sommes-nous"
      data-testid="company-stats-section"
      className="bg-[#f3f4f6] met-section"
    >
      <div className="met-container">
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <div className="text-[#005870] text-xs md:text-sm font-bold tracking-[0.22em] uppercase mb-4">
            Qui sommes-nous
          </div>
          <h2
            data-testid="company-stats-title"
            className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#003242] leading-[1.1] text-balance"
          >
            MET France en quelques chiffres
          </h2>
          <div className="mt-5 mx-auto w-14 h-[3px] bg-[#005870] rounded-full" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {COMPANY_STATS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <div
                key={i}
                data-testid={`company-stat-${i}`}
                className="group bg-white rounded-2xl shadow-met-card hover:shadow-met-card-hover transition-all duration-300 hover:-translate-y-1 border border-[#003242]/5 p-7 md:p-9 flex flex-col items-center text-center"
              >
                <div className="w-12 h-12 rounded-xl bg-[#88d2e7]/25 text-[#005870] flex items-center justify-center mb-6 group-hover:bg-[#005870] group-hover:text-white transition-colors duration-300">
                  {Icon && <Icon size={22} strokeWidth={2} />}
                </div>
                <div className="text-[#003242] text-3xl md:text-4xl font-black tracking-tight leading-none">
                  {s.value}
                </div>
                <div className="mt-3 text-[#1A2E2C]/70 text-sm md:text-base font-medium leading-snug">
                  {s.label}
                </div>
              </div>
            );
          })}
        </div>

        <p
          data-testid="company-stats-description"
          className="mt-12 md:mt-14 text-center text-[#1A2E2C]/75 text-base md:text-lg leading-relaxed max-w-3xl mx-auto font-medium"
        >
          {`Filiale de MET Group, acteur européen de l'énergie présent dans 22 pays, MET France accompagne les professionnels avec des offres sur mesure en électricité et en gaz naturel.`}
        </p>

        <div className="mt-10 flex justify-center">
          <a
            href={SOUSCRIPTION_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="company-stats-cta"
            className="group inline-flex items-center gap-2 border-2 border-[#005870] text-[#005870] hover:bg-[#005870] hover:text-white font-bold text-base px-8 py-4 rounded-full transition-colors duration-300"
          >
            Découvrir nos offres
            <svg className="transition-transform group-hover:translate-x-1" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M13 6l6 6-6 6"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
